module.exports = __webpack_public_path__ + "img/sb-active.5490a0b0.svg";